// 心法沉淀索引表。源文件在 h5/project/5-心法沉淀/<标题>.md
// 维护规则：新写一篇 .md 时同步在这里 append 一条 { date, title }。
// title 不含书名号 / 不含 .md 后缀，与文件名（去括号）一致。

// 注：源文件触发场景里都写的是各自产出日。
// 这里展示用，每天一条，最新一篇在今天。
export const INSIGHTS = [
  { date: '2026-05-22', title: '说得越对，越没人听' },
  { date: '2026-05-23', title: 'Bug 列表越记越长？你可能在重复立案' },
  { date: '2026-05-24', title: '别替他决定，给他选项' },
  { date: '2026-05-25', title: '可点击的东西，永远不要叠在一起' },
  { date: '2026-05-26', title: '要看的钉住，要点的跟来' },
  { date: '2026-05-27', title: '想通了不等于到根了' },
  { date: '2026-05-28', title: '不变才是需要解释的' },
  { date: '2026-05-29', title: '不是所有 bug 都值得追到根' },
  { date: '2026-06-03', title: '为什么被指手画脚的人一定会火' },
  { date: '2026-06-06', title: '你的“顺手”，是我的“惊吓”' },
  { date: '2026-06-07', title: '天天有箭头，等于没箭头' },
  { date: '2026-06-24', title: '删得掉记录，删不掉它' },
  { date: '2026-06-25', title: '顺利，是平庸的温床' },
];

export const INSIGHTS_BY_DATE = INSIGHTS.reduce((acc, it) => {
  (acc[it.date] = acc[it.date] || []).push(it.title);
  return acc;
}, {});
